import RevolutCheckout from "@revolut/checkout";

(() => {
	"use strict";

	const root = document.querySelector("#customer-portal-app");
	if (!root) return;

	const $ = (selector) => document.querySelector(selector);
	const currency = new Intl.NumberFormat("hr-HR", { style: "currency", currency: "EUR" });
	const date = new Intl.DateTimeFormat("hr-HR", { day: "2-digit", month: "2-digit", year: "numeric" });
	const state = {
		overview: null,
		selectedInvoice: null,
		checkoutInstance: null,
		activePayment: null,
	};

	async function api(method, args = {}) {
		const hasArguments = Object.keys(args).length > 0;
		const options = {
			method: hasArguments ? "POST" : "GET",
			credentials: "same-origin",
			headers: { Accept: "application/json" },
		};
		if (hasArguments) {
			options.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
			options.headers["X-Frappe-CSRF-Token"] = window.frappe?.csrf_token || window.csrf_token || "";
			options.body = new URLSearchParams(args).toString();
		}
		const response = await fetch(`/api/method/breskovic_delivery.portal_api.${method}`, options);
		let data;
		try { data = await response.json(); } catch (_) { throw new Error("Poslužitelj nije vratio ispravan odgovor."); }
		if (!response.ok || data.exc) throw new Error(serverMessage(data) || "Dogodila se greška. Pokušajte ponovno.");
		return data.message;
	}

	function serverMessage(data) {
		try {
			const outer = JSON.parse(data._server_messages || "[]");
			return JSON.parse(outer[0]).message;
		} catch (_) { return ""; }
	}

	async function boot() {
		try {
			state.overview = await api("get_portal_overview");
			$("#portal-user").textContent = state.overview.full_name;
			$("#portal-customer").textContent = state.overview.customer;
			renderOverview();
			renderDeliveryNotes();
			$("#portal-content").classList.remove("hidden");
			const returnedInvoice = new URLSearchParams(location.search).get("payment_return");
			if (returnedInvoice) await openInvoice(returnedInvoice);
		} catch (error) {
			$("#portal-alert").textContent = error.message;
			$("#portal-alert").classList.remove("hidden");
		} finally {
			$("#portal-loading").classList.add("hidden");
			root.setAttribute("aria-busy", "false");
		}
	}

	function showPortalView(view) {
		document.querySelectorAll(".portal-view").forEach((element) => element.classList.add("hidden"));
		document.querySelectorAll("[data-portal-view]").forEach((button) => button.classList.toggle("active", button.dataset.portalView === view));
		$(`#${view}-view`).classList.remove("hidden");
	}

	function renderOverview() {
		const invoices = state.overview.invoices || [];
		$("#portal-outstanding").textContent = money(state.overview.outstanding_total);
		$("#portal-open-count").textContent = invoices.filter((row) => ["Unpaid", "Partially Paid", "Overdue"].includes(row.status)).length;
		$("#portal-paid-count").textContent = invoices.filter((row) => row.status === "Paid").length;
		renderInvoices();
	}

	function renderInvoices() {
		const query = normalize($("#portal-search").value);
		const invoices = (state.overview.invoices || []).filter((row) => !query || normalize(row.invoice_number).includes(query));
		$("#portal-invoice-list").innerHTML = invoices.length ? invoices.map((row) => {
			const paid = row.status === "Paid";
			return `<article class="invoice-row" data-invoice="${escapeAttribute(row.name)}" tabindex="0" role="button"><div><span>Broj računa</span><strong>${escapeHtml(row.invoice_number)}</strong></div><div class="invoice-date"><span>Datum</span><strong>${formatDate(row.invoice_date)}</strong></div><div class="invoice-total"><span>Ukupno</span><strong>${money(row.total_amount)}</strong></div><span class="status-pill ${paid ? "paid" : ""}">${statusLabel(row.status)}</span><button class="invoice-open" type="button">OTVORI</button></article>`;
		}).join("") : '<div class="empty-portal"><strong>Nema računa</strong><span>Objavljeni Synesis računi pojavit će se ovdje.</span></div>';
	}

	function renderDeliveryNotes() {
		const query = normalize($("#portal-note-search").value);
		const notes = (state.overview.delivery_notes || []).filter((row) => !query || normalize(row.name).includes(query));
		$("#portal-note-list").innerHTML = notes.length ? notes.map((row) => {
			const pdfUrl = `/api/method/breskovic_delivery.portal_api.download_portal_delivery_note_pdf?name=${encodeURIComponent(row.name)}`;
			const description = Number(row.total_gas_kg || 0) > 0 ? `${Number(row.total_gas_kg).toLocaleString("hr-HR")} kg plina` : "Isporučeni proizvodi";
			const paid = row.payment_status === "Paid";
			const status = paid ? "Plaćeno" : (row.invoice_status === "Invoiced" ? "Fakturirano" : "Nefakturirano");
			return `<article class="invoice-row portal-note-row"><div><span>Otpremnica</span><strong>${escapeHtml(String(row.name).replace("OTP-", "OTP "))}</strong></div><div class="invoice-date"><span>Datum</span><strong>${formatDate(row.delivery_datetime)}</strong></div><div class="invoice-total"><span>Isporuka</span><strong>${escapeHtml(description)}</strong></div><span class="status-pill ${paid || row.invoice_status === "Invoiced" ? "paid" : ""}">${status}</span><a class="invoice-open" href="${pdfUrl}" target="_blank">PDF</a></article>`;
		}).join("") : '<div class="empty-portal"><strong>Nema otpremnica</strong><span>Izdane otpremnice pojavit će se ovdje.</span></div>';
	}

	async function openInvoice(name) {
		try {
			await destroyCheckout();
			state.selectedInvoice = await api("get_portal_invoice", { name });
			const invoice = state.selectedInvoice;
			$("#detail-number").textContent = invoice.invoice_number;
			$("#detail-customer").textContent = state.overview.customer;
			$("#detail-date").textContent = formatDate(invoice.invoice_date);
			$("#detail-due").textContent = invoice.due_date ? formatDate(invoice.due_date) : "—";
			$("#detail-status").textContent = statusLabel(invoice.status);
			$("#detail-total").textContent = money(invoice.total_amount);
			$("#detail-outstanding").textContent = money(invoice.outstanding_amount);
			$("#detail-pdf").href = `/api/method/breskovic_delivery.portal_api.download_portal_invoice_pdf?name=${encodeURIComponent(invoice.name)}`;
			$("#detail-pdf").classList.toggle("hidden", !invoice.has_pdf);
			const payable = ["Unpaid", "Partially Paid", "Overdue"].includes(invoice.status) && Number(invoice.outstanding_amount) > 0;
			$("#detail-pay").classList.toggle("hidden", !payable);
			$("#detail-pay").disabled = !state.overview.payments_configured;
			$("#detail-pay").textContent = state.overview.payments_configured ? "PLATI RAČUN" : "PLAĆANJE USKORO";
			$("#detail-delivery-notes").innerHTML = invoice.delivery_notes.length ? invoice.delivery_notes.map((row) => `<div class="delivery-note-row"><strong>${escapeHtml(String(row.name).replace("OTP-", "OTP "))}</strong><span>${formatDate(row.delivery_datetime)}</span><b>${Number(row.total_kg || 0).toLocaleString("hr-HR")} kg</b></div>`).join("") : '<div class="empty-portal">Nema povezanih otpremnica.</div>';
			$("#checkout-panel").classList.add("hidden");
			$("#checkout-message").classList.add("hidden");
			$("#portal-invoice-dialog").showModal();
		} catch (error) {
			showToast(error.message, true);
		}
	}

	async function startCheckout() {
		const button = $("#detail-pay");
		button.disabled = true;
		button.textContent = "PRIPREMA PLAĆANJA…";
		try {
			await destroyCheckout();
			const order = await api("create_revolut_checkout_order", { invoice: state.selectedInvoice.name });
			state.activePayment = order.payment;
			$("#checkout-panel").classList.remove("hidden");
			state.checkoutInstance = await RevolutCheckout.embeddedCheckout({
				publicToken: order.public_key,
				mode: order.mode,
				locale: "auto",
				target: $("#revolut-checkout-container"),
				createOrder: async () => ({ publicId: order.token }),
				onSuccess: async () => {
					showCheckoutMessage("Plaćanje je zaprimljeno. Provjeravamo potvrdu…", false);
					await refreshPayment();
				},
				onError: () => showCheckoutMessage("Plaćanje nije uspjelo. Pokušajte ponovno.", true),
				onCancel: () => showCheckoutMessage("Plaćanje je prekinuto. Možete pokušati ponovno.", true),
			});
			$("#checkout-panel").scrollIntoView({ behavior: "smooth", block: "start" });
		} catch (error) {
			showCheckoutMessage(error.message, true);
			$("#checkout-panel").classList.remove("hidden");
		} finally {
			button.disabled = false;
			button.textContent = "PLATI RAČUN";
		}
	}

	async function refreshPayment() {
		if (!state.activePayment) return;
		for (let attempt = 0; attempt < 6 && state.activePayment; attempt += 1) {
			try {
				const result = await api("refresh_portal_payment", { payment: state.activePayment });
				if (result.invoice_status === "Paid") {
					showToast("Račun je uspješno plaćen.");
					await destroyCheckout();
					$("#portal-invoice-dialog").close();
					state.overview = await api("get_portal_overview");
					renderOverview();
					return;
				}
			} catch (_) {
				// A webhook can confirm the same payment at this exact moment. Retry quietly.
			}
			showCheckoutMessage("Plaćanje je zaprimljeno. Čekamo potvrdu banke…", false);
			await wait(1500);
		}
		showCheckoutMessage("Plaćanje je zaprimljeno. Potvrda može potrajati kratko; status će se ažurirati automatski.", false);
	}

	async function destroyCheckout() {
		if (state.checkoutInstance?.destroy) await state.checkoutInstance.destroy();
		state.checkoutInstance = null;
		state.activePayment = null;
		$("#revolut-checkout-container").replaceChildren();
	}

	function showCheckoutMessage(message, isError) {
		const element = $("#checkout-message");
		element.textContent = message;
		element.style.background = isError ? "#fff1f0" : "#eef7ef";
		element.style.color = isError ? "#8c1f1b" : "#174b29";
		element.classList.remove("hidden");
	}

	function wait(milliseconds) { return new Promise((resolve) => setTimeout(resolve, milliseconds)); }

	function showToast(message, isError = false) {
		const toast = $("#portal-toast");
		toast.textContent = message;
		toast.style.background = isError ? "#8c1f1b" : "#153f25";
		toast.classList.remove("hidden");
		clearTimeout(showToast.timer);
		showToast.timer = setTimeout(() => toast.classList.add("hidden"), 4500);
	}

	function statusLabel(status) {
		return { Draft: "U pripremi", Unpaid: "Neplaćeno", "Partially Paid": "Djelomično plaćeno", Paid: "Plaćeno", Overdue: "Dospjelo", Cancelled: "Poništeno" }[status] || status;
	}
	function money(value) { return currency.format(Number(value || 0)); }
	function formatDate(value) {
		if (!value) return "—";
		const normalised = String(value).includes(" ") ? String(value).replace(" ", "T") : `${value}T12:00:00`;
		return date.format(new Date(normalised));
	}
	function normalize(value) { return String(value || "").toLocaleLowerCase("hr-HR").normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
	function escapeHtml(value) { const node = document.createElement("div"); node.textContent = value ?? ""; return node.innerHTML; }
	function escapeAttribute(value) { return String(value || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

	$("#portal-search").addEventListener("input", renderInvoices);
	$("#portal-note-search").addEventListener("input", renderDeliveryNotes);
	document.querySelectorAll("[data-portal-view]").forEach((button) => button.addEventListener("click", () => showPortalView(button.dataset.portalView)));
	$("#portal-invoice-list").addEventListener("click", (event) => {
		const row = event.target.closest("[data-invoice]");
		if (row) openInvoice(row.dataset.invoice);
	});
	$("#portal-invoice-list").addEventListener("keydown", (event) => {
		if (event.key === "Enter") {
			const row = event.target.closest("[data-invoice]");
			if (row) openInvoice(row.dataset.invoice);
		}
	});
	$("#detail-pay").addEventListener("click", startCheckout);
	$("#detail-close").addEventListener("click", async () => {
		await destroyCheckout();
		$("#portal-invoice-dialog").close();
	});

	boot();
})();
